import StoreRefreshIcon from './store-refresh-icon';
import UnsupportedMarketplace from './unsupported-marketplace';
import { GatedMarketplace } from './gated-marketplace';
import UserDateFormat from '../../../../components/user-date-format/index';
import style from './style.module.less';
import UserTimeFormat from '../../../../components/user-time-format';
import { Button } from 'ui-components/components/button';
import messages from './messages';
import { FormattedMessage } from 'react-intl';
import { trackWorkflow, WorkflowSteps } from '../../../../tracking/use-workflow-tracking';
import { Workflows } from '../../../../tracking/tracking-constants';

const GetStatusIcon = (isActive, isDeprecated, isMarketPlaceGated, marketplaceId, store) => {
  if (isDeprecated && isActive) {
    return <UnsupportedMarketplace marketplaceId={marketplaceId} />;
  }
  if (isMarketPlaceGated) {
    return <GatedMarketplace marketplaceId={marketplaceId} />;
  }
  return <StoreRefreshIcon store={store} />;
};

const GetStatusMessage = (store, openErrorLog) => {
  const { isActive, refreshedDate, refreshStatus, storeGuid, marketplaceId } = store;

  if (!isActive) {
    return '';
  }
  if (refreshStatus === 'Idle') {
    return (
      <>
        <FormattedMessage {...messages.lastUpdated} /> <UserDateFormat value={refreshedDate} /> <UserTimeFormat value={refreshedDate} />
      </>
    );
  }
  if (['Queued', 'Updating'].includes(refreshStatus)) {
    return <FormattedMessage {...messages.importingOrders} />;
  }
  if (refreshStatus === 'Error') {
    const handleViewDetailsClick = () => {
      trackWorkflow(Workflows.STORE_ERROR_RESOLUTION_FLOW, WorkflowSteps.START, {
        storeGuid,
        marketplaceId,
        source: 'store_settings_page',
      });
      openErrorLog(storeGuid);
    };

    return (
      <>
        <FormattedMessage {...messages.failedToImport} />
        <Button className={style['status-error']} onClick={handleViewDetailsClick} theme='link'>
          <span className={style['update-error-link']}>
            <FormattedMessage {...messages.viewDetails} />
          </span>
        </Button>
      </>
    );
  }
};

export const StoreStatusCell = ({ store, isDeprecated, isMarketPlaceGated, openErrorLog }) => {
  const { isActive, marketplaceId } = store;
  const statusIcon = GetStatusIcon(isActive, isDeprecated, isMarketPlaceGated, marketplaceId, store);
  const statusMessage = GetStatusMessage(store, openErrorLog);
  return (
    <div className={style['status-container']}>
      <div className={style['status-icon-container']}>{statusIcon}</div>
      <div>{statusMessage}</div>
    </div>
  );
};
